import Vue from 'vue';
import Vuex from 'vuex';
import parts_episode from "../data/parts_episode.json";
import ecchr_config from "../data/ecchr_config.json";

Vue.use(Vuex);

export default new Vuex.Store({

    state: {
        participantsVisible: false,
        partsEpisodeVisible: false,
        deepDiveVisible: false,
        explorationVisible: false,
        exploreRelatedContent: false,
        chunkPlayback: "",
        currentPart: "part_1",
        currentPartIndex: 0,
        lastPart: 0,
        episode_id: "",
        episode_index: 0,
        episode_intro_length: "",
        episode_last_chunk: "",
        episode_length: 0,
        device_mode: "",
        speakerBio: "",
        entityObject: Array(),
        imageObject: Array(),
        similarityObject: Array(),
        urlpreviewObject: Array(),
        playbackIndex: 0,
        episodeKey: 0,
    },
    mutations: {
        reRenderEpisode(state) {
            // setTimeout(function () {
            state.episodeKey += 1
            console.log(state.episodeKey)
            // }, 3000)
        },
        updateDeviceMode(state, device) {
            state.device_mode = device
        },
        updateEpisodeId(state, id) {
            state.chunkPlayback = ""
            state.episode_id = id
            state.episode_index = ecchr_config['episode_cards'].map((o) => o.episode_id).indexOf(state.episode_id);
            state.episode_length = ecchr_config['episode_cards'][state.episode_index]["episode_length"]
            state.episode_intro_length = ecchr_config['episode_cards'][state.episode_index]["episode_intro_length"]
            state.episode_last_chunk = ecchr_config['episode_cards'][state.episode_index]["episode_last_chunk"]
            state.entityObject = Array()
            state.imageObject = Array()
            state.similarityObject = Array()
            state.urlpreviewObject = Array()
        },
        updateEpisodeIndex(state, index) {
            state.episode_index = index
        },
        updateEpisodeLength(state, length) {
            state.episode_length = length
        },
        updatePlaybackIndex(state, playbackIndex) {
            state.playbackIndex = playbackIndex
            // console.log(state.playbackIndex)
        },
        updateEntityObject(state, entity) {
            state.entityObject.push(entity)
            // console.log(state.entityObject)
        },
        updateImageObject(state, image) {
            state.imageObject.push(image)
            // console.log(state.imageObject)
        },
        updateSimilarityObject(state, similarity) {
            state.similarityObject.push(similarity)
            // console.log(state.similarityObject)
        },
        updateUrlPreviewObject(state, urlpreview) {
            console.log(urlpreview)
            state.urlpreviewObject.push(urlpreview)
        },
        // updateLastPart(state, last) {
        //     state.lastPart = last
        // },
        nextPart(state) {
            let part_number = state.currentPart.split('_')[1]
            state.chunkPlayback = parts_episode[state.episode_id][part_number].chunk
            part_number = parseInt(part_number) + 1
            const new_part = "part_" + part_number
            state.currentPart = new_part
            state.currentPartIndex = state.currentPart.split('_')[1] - 1
            // console.log("next: " + state.chunkPlayback)
        },
        prevPart(state) {
            let part_number = state.currentPart.split('_')[1]
            part_number = parseInt(part_number) - 1
            // console.log(part_number)
            const new_part = "part_" + part_number
            state.currentPart = new_part
            state.chunkPlayback = parts_episode[state.episode_id][part_number - 1].chunk
            // console.log("prev: " + state.chunkPlayback)
            state.currentPartIndex = state.currentPart.split('_')[1] - 1
        },
        updatePart(state, partIndex) {
            state.currentPart = partIndex
            state.currentPartIndex = partIndex.split('_')[1] - 1
        },
        updateChunkPlayback(state, payload) {
            state.chunkPlayback = payload
            console.log(state.chunkPlayback)
        },
        updateChunkPlaybackSimilar(state, payload) {
            console.log(payload)
            setTimeout(function () {
                state.chunkPlayback = payload
            }, 1000)
        },
        toggleParticipants(state) {
            state.participantsVisible = !state.participantsVisible
        },
        togglePartsEpisode(state) {
            state.partsEpisodeVisible = !state.partsEpisodeVisible
        },
        toggleDeepDive(state) {
            state.deepDiveVisible = !state.deepDiveVisible
        },
        toggleExploration(state) {
            state.explorationVisible = !state.explorationVisible
        },
        updateExploration(state, payload) {
            state.explorationVisible = payload
        },
        toggleExploreRelatedContent(state) {
            if (state.exploreRelatedContent == true) {
                state.exploreRelatedContent = false;
            }

            setTimeout(function () {
                if (state.entityObject[state.playbackIndex].length ||
                    state.similarityObject[state.playbackIndex].length ||
                    state.imageObject[state.playbackIndex].length ||
                    state.urlpreviewObject[state.playbackIndex].length != 0
                    // &&
                    // state.entityObject[state.playbackIndex].length ||
                    // state.similarityObject[state.playbackIndex].length ||
                    // state.imageObject[state.playbackIndex].length != undefined
                ) {
                    state.exploreRelatedContent = true;
                } else {
                    state.exploreRelatedContent = false;
                }
            }, 200);
        },
        updateSpeakerBio(state, payload) {
            state.speakerBio = payload;
        }
    },
    getter: {
    },
    actions: {
    },
    models: {
    }
});